module.exports = __webpack_public_path__ + "static/media/500km.af796bf9.png";